import React from 'react';

import Show from 'components/Show';
import Editor from 'components/Editor';
import { Button } from 'components/Misc/Form';

import Option from 'containers/Shared/Tasks/Task/Option';
import { Title } from 'components/Misc/Typography';

import { useExamProfileStore } from 'store/exam/useExamProfileStore';
import { useTaskCreateStore } from 'store/task/useTaskCreateStore';

const Question = ({ idx, question }) => {
	// Use exam's profile store
	const slug = useExamProfileStore(state => state.exam.slug);

	// Use task's create store
	const [type, onChangeQuestion, onRemoveQuestion, onAddOption, onChangeWord, onAddWord, onRemoveWord] = useTaskCreateStore(state => [
		state.task.type,
		state.onChangeQuestion,
		state.onRemoveQuestion,
		state.onAddOption,
		state.onChangeWord,
		state.onAddWord,
		state.onRemoveWord
	]);

	// Handles question's onChange event
	const onChange = change => onChangeQuestion(question.key, change);

	// Handles question's onRemove event
	const onRemove = () => onRemoveQuestion(question.key);

	// Handles question's onAdd event
	const onAdd = () => onAddOption(question.key);

	// Handle word's onChange event
	const onWordChange = change => onChangeWord(question.key, change);

	// Handle word's onAdd event
	const onWordAdd = key => onAddWord(question.key, key);

	// Handle word's onRemove event
	const onWordRemove = key => onRemoveWord(question.key, key);

	return (
		<div className="flex flex-col items-start">
			{/* Question's title */}
			<div className="mb-4 w-full flex items-center">
				<Title
					title={`${idx + 1}. Jautājums`}
					className="flex-1"
				/>

				<Button
					small
					square
					icon="delete"
					theme="danger"
					onClick={onRemove}
					className="font-normal"
				/>
			</div>

			{/* Question's content */}
			<Editor
				type={type === 'spellcheck' ? 'spellcheck' : 'question'}
				name="content"
				path="exams"
				folder={slug}
				value={question.content}
				onChange={onChange}
				spellcheck={type === 'spellcheck' ? {
					mode: 'edit',
					words: question.words,
					onWordChange: onWordChange,
					onWordAdd: onWordAdd,
					onWordRemove: onWordRemove,
				} : false}
			/>

			{/* Quiz's options */}
			<Show if={question.options?.length}>
				<div className="mt-4 flex flex-col w-full gap-4">
					<Title
						title="Atbilžu varianti"
					/>

					{question.options?.map(option =>
						<Option
							key={option.key}
							option={option}
							questionKey={question.key}
						/>
					)}
				</div>
			</Show>
			
			{/* Connect's answer */}
			<Show if={type === 'connect'}>
				<Title
					title="Atbilde"
					className="my-4"
				/>
			
				<Editor
					type="answer"
					name="answer"
					path="exams"
					folder={slug}
					value={question.answer}
					onChange={onChange}
				/>
			</Show>
			
			{/* Question's actions */}
			<Show if={type === 'quiz'}>
				<Button
					icon="add"
					value="Pievienot atbilžu variantu"
					onClick={onAdd}
					className="mt-4"
				/>
			</Show>
		</div>
	);
};

export default Question;